import {firestoreAction} from "vuexfire";
import {db} from '@/firebase'

const state = {
    deviceParts:[],
    devicePartsFaulty:[],
};

const getters = {
    deviceParts: state => state.deviceParts,
    devicePartsFaulty: state => state.devicePartsFaulty,
};

const actions = {

    /** Add a part */
    addPart(__, {jobId, deviceId, faulty = false, stockSerialNumberId, stockItemId, oldSerialNumber = null, newSerialNumber = null}) {
        return new Promise((resolve, reject) => {
            db.collection(`jobs/${jobId}/devices/`)
                .doc(deviceId)
                .update({no_parts_used: false})
                .then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                })

            let serialNumbersSaved = (oldSerialNumber && newSerialNumber);

            db.collection(`stock_items`).doc(stockItemId.toString())
                .get()
                .then(document => {

                    let stockItem = document.data();

                    db.collection(`jobs/${jobId}/devices/${deviceId}/parts`).doc(stockSerialNumberId.toString())
                        .set({
                            faulty:faulty,
                            id: stockSerialNumberId,
                            lcd_working: false,
                            stock_item_id: stockItemId,
                            stock_item_title: stockItem.title,
                            stock_item_type: stockItem.type,
                            stock_item_type_id: stockItem.type_id,
                            serial_numbers_saved: serialNumbersSaved,
                            old_serial_number: oldSerialNumber,
                            new_serial_number: newSerialNumber,
                        }).then(() => {
                            resolve();
                        }).catch(() => {
                            reject();
                        });

                });
        });
    },

    /** Load faulty parts */
    loadFaultyParts: firestoreAction(({bindFirestoreRef}, {jobId, deviceId}) => {
        return bindFirestoreRef(
            'devicePartsFaulty',
            db.collection(`jobs/${jobId.toString()}/devices/${deviceId.toString()}/parts`)
                .where('faulty', '==', true)
        )
    }),

    /** Load a parts for a device */
    loadParts: firestoreAction(({bindFirestoreRef}, {jobId, deviceId}) => {
        return bindFirestoreRef(
            'deviceParts',
            db.collection(`jobs/${jobId.toString()}/devices/${deviceId.toString()}/parts`)
                .where('faulty', '==', false)
                .orderBy('stock_item_title')
        )
    }),

    /** Mark part as faulty */
    markPartAsFaulty(__, {jobId, deviceId, stockSerialNumberId}) {
        return new Promise((resolve, reject) => {

            let serialNumberReference = db.collection(`jobs/${jobId}/devices/${deviceId}/parts`).doc(stockSerialNumberId.toString());

            serialNumberReference.get()
                .then((snapshot) => {

                    if (!snapshot.exists) {
                        reject("Part not added, Please add this part first then mark as faulty.");
                    }

                    db.collection(`jobs/${jobId}/devices/${deviceId}/parts`).doc(stockSerialNumberId.toString())
                        .update({
                            faulty: true
                        }).then(() => {
                            resolve();
                        }).catch(() => {
                            reject();
                        });
                });
        });
    },

    /** Mark part as not faulty */
    markPartAsNotFaulty(__, {jobId, deviceId, stockSerialNumberId}) {
        return new Promise((resolve, reject) => {

            let serialNumberReference = db.collection(`jobs/${jobId}/devices/${deviceId}/parts`).doc(stockSerialNumberId.toString());

            serialNumberReference.get()
                .then((snapshot) => {

                    if (!snapshot.exists) {
                        reject("Part not added, Please add this part first then mark as faulty.");
                    }

                    db.collection(`jobs/${jobId}/devices/${deviceId}/parts`).doc(stockSerialNumberId.toString())
                        .update({
                            faulty:false
                        }).then(() => {
                            resolve();
                        }).catch(() => {
                            reject();
                        });
                });
        });
    },

    /** Remove a part */
    removePart(__, {jobId, deviceId, stockSerialNumberId}) {
        return new Promise((resolve, reject) => {
            db.collection(`jobs/${jobId}/devices/${deviceId}/parts`)
                .doc(stockSerialNumberId.toString())
                .delete()
                .then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                });
        });
    },

    /** Set can't add serial */
    setNoSerialSupplied(__, {jobId, deviceId}) {
        return new Promise((resolve, reject) => {
            db.collection(`jobs/${jobId}/devices`)
                .doc(deviceId)
                .update({no_serial_supplied: true})
                .then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                })
        });
    },

    /** Set no parts required */
    setNoPartsRequired(__, {jobId, deviceId}) {
        return new Promise((resolve, reject) => {
            db.collection(`jobs/${jobId}/devices`)
                .doc(deviceId)
                .update({no_parts_used: true})
                .then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                })
        });
    }
};

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
}